const FIRMWARE_SECRET_TAP_COUNT = 5;
const FIRMWARE_SECRET_TAP_INTERVAL_MS = 600;

function createFirmwareSecretTapGate({
  requiredCount = FIRMWARE_SECRET_TAP_COUNT,
  intervalMs = FIRMWARE_SECRET_TAP_INTERVAL_MS,
  now = () => Date.now(),
} = {}) {
  let tapCount = 0;
  let lastTapAt = null;

  return {
    registerTap() {
      const currentTime = now();

      // 超过连续点击时间窗后，重新开始计数。
      if (lastTapAt === null || currentTime - lastTapAt > intervalMs) {
        tapCount = 0;
      }

      tapCount += 1;
      lastTapAt = currentTime;

      if (tapCount < requiredCount) {
        return false;
      }

      tapCount = 0;
      lastTapAt = null;
      return true;
    },
  };
}

module.exports = {
  createFirmwareSecretTapGate,
  FIRMWARE_SECRET_TAP_COUNT,
  FIRMWARE_SECRET_TAP_INTERVAL_MS,
};
